<template>
  <div class="zw-product-four-template">
    <!--    背景图-->
    <div
      :style="{backgroundImage:'url('+ bgImgUrl +')'}"
      class="zw-four-bg"
    >
      <div class="zw-four-bg-tile">
        <div>财政指标管理系统</div>
        <span>科学管财政指标，强化预算执行</span>
      </div>
    </div>
    <div class="zw-four-bg-introduc">
      <div
        style="display: flex;justify-content: center;align-items: center;
        margin-bottom: 20px"
      >
        <img src="../../assets/image/product/fourLeft.png" alt="">
        <div
          style="font-size: 28px;font-weight: bold;color: #000000;
         padding: 0 20px"
        >系统简介</div>
        <img src="../../assets/image/product/fourRight.png" alt="">
      </div>
      <div
        style="display: flex;padding: 50px 0 0;width: 100%;
      justify-content: center;flex-direction: column"
      >
        <div
          style="font-size: 16px;color: #000000;
        line-height: 26px"
        >
          财政预算指标管理平台，是一款旨在推动财政数字化转型的一体化协同平台。本产品严格遵循国家政策导向，致力于解决财政局在预算指标管理中长期存在的公文流转慢、业务协同难、数据不互通、监控不透明等核心痛点。平台通过将公文审批、指标管理、指标监控等全业务流程线上化、数字化，构建“业务-公文-数据”一体贯通的数字基座，实现从“流程线上化”到“治理数字化”的跨越。它能显著提升公文处理与跨部门协作效率，实现业务全程可追溯、风险智能预警，助力财政局实现“减负增效、全景可视、整体智治”的管理目标，筑牢安全智能的财政数字运营核心。
        </div>
        <el-divider />
      </div>
    </div>
    <div class="zw-four-bg-trait">
      <div
        style="display: flex;justify-content: center;align-items: center;
        margin-bottom: 20px"
      >
        <img src="../../assets/image/product/fourLeft.png" alt="">
        <div
          style="font-size: 28px;font-weight: bold;color: #000000;
          padding: 0 20px"
        >系统特点</div>
        <img src="../../assets/image/product/fourRight.png" alt="">
      </div>
      <div class="zw-trait-context">
        <ul>
          <li v-for="(item, index) in traitList" :key="index">
            <el-card style="width: 100%" shadow="always">
              <div style="display: flex;align-items: center;width: 100%;justify-content: space-between;">
                <div style="text-align: center;padding-right: 20px;">
                  {{ item.text }}
                </div>
                <img :src="item.imgUrl" width="100px" height="100px" alt="">
              </div>
            </el-card>
          </li>
        </ul>
      </div>
    </div>
    <!--免费获取方案-->
    <div
      :style="{backgroundImage:'url('+ fontImg +')'}"
      class="zw-four-footer"
    >
      <div
        style="display: flex;align-items: center;height: 100%;
      justify-content: center;flex-direction: column"
      >
        <div style="font-size: 28px;font-weight: bold;color: #000000;padding-bottom: 30px">
          即刻为你的企业定制解决方案
        </div>
        <el-button size="small" type="primary" @click="handleProgramme">免费获取方案</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'APM',
  data() {
    return {
      bgImgUrl: require('../../assets/image/product/fourBg.jpg'),
      fontImg: require('../../assets/image/product/fourfoot.jpg'),
      traitList: [
        {
          imgUrl: require('../../assets/image/product/four01.png'),
          text: '线上协同与移动审批：支持全流程线上流转与移动签批，打破时空限制，让紧急公文与事项审批随时处理，效率倍增;'
        },
        {
          imgUrl: require('../../assets/image/product/four02.png'),
          text: '领导驾驶舱全景监控：为管理层提供业务全景可视化驾驶舱，实现对进度、风险的全局把控与主动预警，变被动汇报为精准指挥;'
        },
        {
          imgUrl: require('../../assets/image/product/four03.png'),
          text: '指标台账自动生成与追溯：自动汇聚公文与业务数据，一键生成精准、规范的指标台账与报表，并支持全链条穿透追溯，轻松应对审计与统计;'
        },
        {
          imgUrl: require('../../assets/image/product/four04.png'),
          text: '业文一体化闭环管理：无缝对接财政云等业务系统，打通“公文审批”与“指标业务”断点，驱动数据自动同步，形成完整的线上管理闭环。'
        }
      ]
    }
  },
  methods: {
    // 免费获取方案
    handleProgramme() {
      this.$router.push({
        path: '/getScheme'
      })
    }
  }
}
</script>

<style scoped>

</style>
